import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { document, create_mrn } from './api';

const initialState = {
  allMaterials: [],
  material: {},
  pagination: [],
  getAllMaterilLoading: null,
  MaterialsList: [],
  suppliers: []
};

const actions = {
  GET_ALL_MATERIALS: 'materials/GET_ALL_MATERIALS',
  GET_DOCS_BY_ID: 'materials/GET_DOCS_BY_ID'
};

export const getDocsbyId = createAsyncThunk(
  actions.GET_DOCS_BY_ID,
  async (payload) => {
    const response = await document('all', payload);

    return response;
  }
);

export const createMRN = createAsyncThunk(
  actions.CREATE_MATERIAL,
  async (payload) => {
    const response = await create_mrn('generate', payload);
    return response;
  }
);

export const batchSlice = createSlice({
  name: 'batch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocsbyId.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(getDocsbyId.fulfilled, (state, action) => {
        state.getAllMaterilLoading = false;

        const { success, data } = action.payload;
        if (success) {
          state.material = data;
        } else {
          state.material = '';
        }
      })
      .addCase(getDocsbyId.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });

    builder
      .addCase(createMRN.pending, (state) => {
        state.getAllMaterilLoading = true;
      })
      .addCase(createMRN.fulfilled, (state, action) => {
        state.getAllMaterilLoading = false;

        const { sucess, message: msg } = action.payload;
        if (!sucess) {
          message.error(msg);
        }
      })
      .addCase(createMRN.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllMaterilLoading = false;

        message.error(msg);
      });
  }
});
export default batchSlice.reducer;
